var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLizenz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Lizenz__Icn/40px/Lizenz",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9995163,7 C24.4117143,7 28,10.5879435 28,15.0004837 C28,17.5214802 26.828259,19.7734248 25.0006742,21.2406229 L25,32.3265496 L20,27.585 L15,32.3265496 L14.9997932,21.2414658 C13.1718964,19.7743112 12,17.5220184 12,15.0004837 C12,10.5878021 15.5874598,7 19.9995163,7 Z M23.0009441,22.4160888 C22.0737147,22.7925542 21.060425,23 19.9995163,23 C18.9394019,23 17.9268777,22.7928596 17.0002815,22.4169164 L17,27.672 L20,24.8283577 L23,27.673 L23.0009441,22.4160888 Z M19.9995163,9 C16.692072,9 14,11.6923289 14,15.0004837 C14,17.1794609 15.168588,19.0914386 16.9117656,20.1424181 L17,20.1426427 L17.0000388,20.1946169 C17.8830262,20.706634 18.9077571,21 19.9995163,21 C21.0919802,21 22.1173943,20.7062707 23.0008691,20.1936811 L23,20.1426427 L23.0876174,20.1423727 C24.8310855,19.0913449 26,17.1793162 26,15.0004837 C26,11.6925557 23.3071875,9 19.9995163,9 Z M19.9997927,11 C22.2063138,11 24,12.7935151 24,15.0002073 C24,17.2065704 22.2062282,19 19.9997927,19 C17.7933934,19 16,17.2066066 16,15.0002073 C16,12.793479 17.7933079,11 19.9997927,11 Z M19.9997927,13 C18.8979201,13 18,13.8980057 18,15.0002073 C18,16.1020371 18.8979629,17 19.9997927,17 C21.1017441,17 22,16.1019155 22,15.0002073 C22,13.8981273 21.101787,13 19.9997927,13 Z",
    id: ".._.._src_svg_Icn_40px_Lizenz__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLizenz);
export default __webpack_public_path__ + "static/media/Lizenz.111fa04c321f1a7aa0686e75e9df2332.svg";
export { ForwardRef as ReactComponent };